import SearchAddressInput from './SearchAddressInput.vue';

export default SearchAddressInput;
